// extracted by mini-css-extract-plugin
export default {"wrapper":"CookieSettingsForm--wrapper--+da4L","switch":"CookieSettingsForm--switch--GnQsW","button":"CookieSettingsForm--button--01ZHv"};